<template>
    <div class="agent_container">
        <CustomHeader text="Agente" @closePopup="close" />
        <div class="container">
            <img :src="dataSet.bannerImage" alt="">
            <van-tabs v-model="active" sticky :ellipsis="false" @click-tab="onClickTab">
                <van-tab v-for="(item, index) in tabList" :key="index" :title="$t(item.name)" :name="index">
                </van-tab>
            </van-tabs>

        </div>
        <div class="tab-content-wrapper" ref="contentWrapper">
            <InvitationView v-if="dataSet.activeTab == 0" @closePoup="close" />
            <MyDataView v-if="dataSet.activeTab == 1" />
            <CommissionView v-if="dataSet.activeTab == 2" />
            <DetailsView v-if="dataSet.activeTab == 3" />
            <FaqView v-if="dataSet.activeTab == 4" />
        </div>
    </div>

</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import InvitationView from './components/invitationView.vue';
import MyDataView from './components/myDataView.vue';
import CommissionView from './components/commissionView.vue';
import DetailsView from './components/detailsView.vue';
import FaqView from './components/faqView.vue';
import { useI18n } from 'vue-i18n';
import { useActivityStore } from '@/stores/activity';
import { AgentData, TAB_LIST } from '@/view/agent/supportScript';
import CustomHeader from '../components/common/customHeader.vue';
import { useRouter } from 'vue-router';
const router = useRouter()
const { t } = useI18n();
const show = ref(false)

const tabList = ref(TAB_LIST)
const activeTab = ref(0)
const emit = defineEmits(['onClickTab', 'close', 'update:show'])
const contentWrapper = ref<HTMLElement | null>(null);
const props = defineProps<{
    dataSet: AgentData
}>()
const active = ref(props.dataSet.activeTab)

watch(active, (val) => {
    emit('update:show', val)
})

watch(() => props.dataSet.activeTab, () => {
    if (contentWrapper.value) {
        contentWrapper.value.scrollTop = 0; // Reset local scroll to top
    }
});
const close = () => {
    router.go(-1)
}
const onClickTab = (value: any) => {
    emit('onClickTab', value)
}

</script>
<style scoped>
.agent_container {
    /* min-height: 100vh; */
    padding: 110px 0 0;
    /* overflow-y: auto; */
}

.agent_container::-webkit-scrollbar {
    display: none;
}

.container {
    width: 100%;
    position: absolute;
    top: 35px;
    z-index: 1;
}

.container>>>.van-tabs__wrap {
    background: rgb(0, 33, 33);
    backdrop-filter: blur(8px);
    padding: 20px 0 0;
}

.container>>>.van-tabs__nav {
    background: transparent;
    padding: 0;
}

.container>>>.van-tab:hover {
    background-color: #00113135;
}

.container>>>.van-tab {
    color: rgba(255, 255, 255, 0.4);
    border-radius: 10px 10px 0 0;
    font-size: 18px;
    font-weight: 500;
    margin: 0 3px;
    padding: 0x 10px;
    min-width: 25%;
}

.container>>>.van-tab.van-tab--active {
    color: rgb(13, 176, 174);
    background: rgb(2, 74, 73);
    font-weight: bold;
    border-bottom: 3px solid rgb(13, 176, 174);
    padding: 10px;
}

.container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

.tab-content-wrapper {
    height: calc(100vh - 150px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
}
.tab-content-wrapper:-webkit-scrollbar {
    display: none;
}
:deep(.van-tabs__wrap),
:deep(.van-tabs__scroll),
:deep(.van-tabs__nav),
:deep(.van-tabs__nav--line),
:deep(.van-tab) {
    scrollbar-width: none !important;
    /* Firefox */
}

:deep(.van-tabs__wrap::-webkit-scrollbar),
:deep(.van-tabs__scroll::-webkit-scrollbar),
:deep(.van-tabs__nav::-webkit-scrollbar),
:deep(.van-tabs__nav--line::-webkit-scrollbar),
:deep(.van-tab::-webkit-scrollbar) {
    display: none !important;
    /* Chrome, Safari, Edge */
}

@media (max-width: 450px) {
    .container>>>.van-tab {
        font-size: 15px;
    }
}
</style>